import React, { useState, useEffect } from "react";
import VendorServices from "services/VendorServices";
import Select from "react-select";
const SelectReferenceNo = ({
  register,
  handleReferenceNoChange,
  name,
  label,
  selectedReferenceNoId,
}) => {
  const [referenceNos, setReferenceNo] = useState([]);
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: "RRGGBB",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
        ? "rgba(0, 0, 0, 0.15)"
        : "white",
      color: state.isSelected ? "white" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)", // Change the background color on hover
        color: "black", // Change the text color on hover
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: "10px 0 -10px 0", // Add margin to the entire option box
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
  };
  useEffect(() => {
    async function fetchReferenceNo() {
      try {
        const response = await VendorServices.getAllReferenceNo();
        const transformedData = response.map((item) => ({
          value: item.id,
          label: item.company_name,
        }));
        setReferenceNo(transformedData);
      } catch (error) {
        console.error("Error fetching referenceNos:", error);
      }
    }

    fetchReferenceNo();
  }, []);

  const handleReferenceNoSelect = async (selected) => {
    const item = referenceNos.find((item) => item.value === selected.value);
    if (item) {
      handleReferenceNoChange(selected.value); // Pass the selected value to the parent
    }
  };

  return (
    <Select
      className="dark:text-gray-300 leading-5 rounded-md focus:border-gray-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300 dark:bg-gray-700 border h-10 text-sm focus:outline-none block w-full bg-white-100  border-transparent focus:bg-white"
      // isSearchable={false}
      {...register(`${name}`, {
        required: !selectedReferenceNoId ? `${label} is required!` : false,
      })}
      name={name}
      styles={customSelectStyles}
      options={referenceNos}
      onChange={handleReferenceNoSelect}
      value={referenceNos.find(
        (option) => option.value === selectedReferenceNoId
      )}
    />
  );
};

export default SelectReferenceNo;
